// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
// Font awesome
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)

import resource from 'vue-resource';
Vue.use(resource);

/***** Bootstrap-Vue *****/
// import { BootstrapVue } from 'bootstrap-vue'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// Vue.use(BootstrapVue)
/***** Bootstrap-Vue *****/

import CookieLaw from 'vue-cookie-law';
Vue.use(CookieLaw);

Vue.config.productionTip = false

Vue.prototype.$constants = {
  owner: 'igprog',
  appName: 'IG PROG',
  appDesc: 'Programska rješenja po Vašoj mjeri',
  appDomain: 'igprog.hr',
  company: 'IG PROG, obrt za računalno programiranje',
  address: 'Ludvetov breg 5, 51000 Rijeka, Hrvatska',
  phone: '+385 98 330 966',
  phoneShort: '098 330 966',
  email: 'info@igprog.hr',
  pin: '07474673441',
  sendTo: 'info@igprog.hr',
  googleMap: null, //'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2804.321230545586!2d14.398239815067406!3d45.34232744958904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4764a6db255cc875%3A0x31bb44b2564cc951!2sKr%C5%A1ini%C4%87eva%20ul.%2020%2C%2051000%2C%20Rijeka!5e0!3m2!1sen!2shr!4v1629986377460!5m2!1sen!2shr'
  links: [
    { domain: 'igprog.hr', title: 'IG PROG - obrt za računalno programiranje' },
    { domain: 'programprehrane.com', title: 'Web aplikacija za izradu uravnoteženih jelovnika' },
    { domain: 'plan-ishrane.com', title: 'Zdrva ishrana uz pomoć veb aplikacije' },
    { domain: 'vistanekretnine.hr', title: 'Prodaja luksuznih stanova - Opatija' },
    { domain: 'dizajn911.com', title: 'Dizajn interijera - Kastav' },
    { domain: 'elsolution.hr', title: 'Elektroinstalacijski radovi - Rijeka' },
    { domain: 'villamilibrela.com', title: 'Villa Mili - Brela' },
    { domain: 'apartmanbepinasplit.com', title: 'Apartman Bepina - Split' },
    { domain: 'apartmentverano.com', title: 'Apartman Verano - Njivice' },
    { domain: 'programishrane.rs', title: 'Program Ishrane' },
    { domain: 'nutriprog.com', title: 'Nutrition Program' },
  ]
}

Vue.prototype.$isLogin = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js